import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["header", "panel", "hint", "icon"];

  static values = {
    open: { type: Boolean, default: false },
    closedClass: { type: String, default: "bg-gray-200 hover:bg-gray-300" },
    openClass: { type: String, default: "bg-white hover:bg-gray-50" },
  };

  connect() {
    this.sync();
  }

  toggle(event) {
    event.preventDefault();
    this.openValue = !this.openValue;
    this.sync();
  }

  sync() {
    const isOpen = this.openValue;

    if (this.hasPanelTarget) {
      this.panelTarget.classList.toggle("hidden", !isOpen);
    }

    if (this.hasHeaderTarget) {
      this.headerTarget.setAttribute("aria-expanded", isOpen ? "true" : "false");
      this.applyHeaderClasses(isOpen);
    }

    if (this.hasHintTarget) {
      this.hintTarget.textContent = isOpen ? "Clique para recolher" : "Clique para expandir";
    }

    if (this.hasIconTarget) {
      this.iconTarget.style.transform = isOpen ? "rotate(180deg)" : "rotate(0deg)";
    }
  }

  applyHeaderClasses(isOpen) {
    const closed = (this.closedClassValue || "").split(/\s+/).filter(Boolean);
    const open = (this.openClassValue || "").split(/\s+/).filter(Boolean);

    if (isOpen) {
      closed.forEach((c) => this.headerTarget.classList.remove(c));
      open.forEach((c) => this.headerTarget.classList.add(c));
    } else {
      open.forEach((c) => this.headerTarget.classList.remove(c));
      closed.forEach((c) => this.headerTarget.classList.add(c));
    }
  }
}
